/* eslint-disable */
import * as yup from 'yup'
import { AddAppraisalMediaInput, AddAssetMediaInput, AddConditionStatusReportMediaInput, AddRestorationMediaInput, AddUserObjectPermissionFromCollectionInput, AddUserObjectPermissionInput, AddUserPermissionInput, AddUserSignatureInput, AddressInput, AppraisalInput, AssetDocumentAttachmentInput, AssetDocumentInput, AssetElementInput, AssetInput, AssetPresentValueInput, BaseEventLogAuctionRightsCurrencyChoices, BaseEventLogExternalEntityChoices, BaseEventLogMaximumPriceCurrencyChoices, BaseEventLogMinimumPriceCurrencyChoices, BaseEventLogReservePriceCurrencyChoices, BaseEventLogValueCurrencyChoices, CertificateInput, ChangeAssetCategoryInput, ChangePasswordInput, CloseAppraisalInput, CloseConditionStatusReportInput, CloseRestorationInput, CollectionInput, CompanyContactInput, ConditionStatusReportInput, CreateAppraisalInput, CreateAssetDocumentAttachmentInput, CreateAssetDocumentInput, CreateAssetElementInput, CreateAssetInput, CreateAssetPresentValueInput, CreateCertificateInput, CreateCertificateTemplateInput, CreateCollectionInput, CreateCompanyContactInput, CreateConditionStatusReportInput, CreateEventLogInput, CreateExhibitionInput, CreateInsuranceInput, CreateMediaInput, CreateOfficeInput, CreatePolicyAssetInput, CreatePolicyDocumentInput, CreatePolicyInput, CreatePolicyNoteInput, CreateRegistryInput, CreateRegistryWithCompanyContactInput, CreateRestorationInput, CreateUserInput, DeleteAppraisalInput, DeleteAppraisalMediaInput, DeleteAssetCarryingValueFileInput, DeleteAssetDocumentAttachmentInput, DeleteAssetDocumentInput, DeleteAssetElementInput, DeleteAssetInput, DeleteAssetMediaInput, DeleteAssetPresentValueInput, DeleteCertificateInput, DeleteCertificateTemplateInput, DeleteCollectionInput, DeleteCompanyContactInput, DeleteConditionStatusReportInput, DeleteConditionStatusReportMediaInput, DeleteEventLogInput, DeleteExhibitionInput, DeleteInsuranceInput, DeleteMediaInput, DeleteOfficeInput, DeletePolicyAssetInput, DeletePolicyDocumentInput, DeletePolicyInput, DeletePolicyNoteInput, DeleteRegistryInput, DeleteRestorationInput, DeleteRestorationMediaInput, DeleteUserInput, DeleteUserSignatureInput, DetachAssetFromAppraisalInput, DetachAssetFromCollectionInput, DetachAssetFromConditionStatusReportInput, DetachAssetFromExhibitionInput, DetachAssetFromRestorationInput, DuplicatePolicyInput, EventLogInput, ExhibitionInput, ExportAppraisalPdfInput, ExportAssetPdfInput, ExportCollectionPdfInput, ExportConditionStatusReportPdfInput, ExportExhibitionPdfInput, ExportPolicyPdfInput, ExportRestorationPdfInput, ExtendPolicyInput, GenerateCertificateInput, GenerateGroupedCertificateInput, GenerateSplitCertificateInput, GroupedPolicyAssetInput, InsuranceInput, InvalidateCertificateInput, InviteUserInput, ManagementAppraisalValueCarryingValueCurrencyChoices, ManagementAppraisalValueEstimatedValueCurrencyChoices, ManagementAssetPresentValueAmountCurrencyChoices, ManagementConditionStatusReportValueEstimatedValueCurrencyChoices, ManagementConditionStatusReportValueEstimatedValueExaminationTimeCurrencyChoices, ManagementInsuranceContractTypeChoices, ManagementInsuranceCoverageTypeChoices, ManagementInsuranceEvaluationTypeChoices, ManagementInsuranceInsuranceReasonChoices, ManagementInsuranceRiskCoveredTypeChoices, ManagementRestorationRestorationCostCurrencyChoices, MediaInput, MoneyInput, OfficeInput, PolicyAssetInput, PolicyDocumentInput, PolicyInput, PolicyNoteInput, RegistryInput, RemoveUserObjectPermissionInput, RenewPolicyInput, RenewUserInput, RequestUserResetPasswordInput, ResetUserPasswordInput, RestorationInput, RevertPolicyInput, SetMainSignatureInput, SignCertificateInput, SpinCertificateCertificateTypeChoices, SpinCertificateGroupingChoices, SpinPolicyAssetBasketHistoryCoverTypeChoices, SpinPolicyAssetBasketHistoryCoveredRiskTypeChoices, SpinPolicyAssetBasketHistoryEvaluationTypeChoices, SpinPolicyAssetBasketHistoryInsuredValueCurrencyChoices, SpinPolicyAssetBasketHistoryStatusChoices, SpinPolicyBasketHistoryStatusChoices, SpinPolicyEventsActionChoices, TerminatePolicyInput, ToggleUserIsActiveInput, ToggleUserUserTypeInput, UpdateAppraisalInput, UpdateAssetDocumentAttachmentInput, UpdateAssetDocumentInput, UpdateAssetElementInput, UpdateAssetInput, UpdateAssetPresentValueInput, UpdateCertificateInput, UpdateCollectionInput, UpdateCompanyContactInput, UpdateConditionStatusReportInput, UpdateEventLogInput, UpdateExhibitionInput, UpdateInsuranceInput, UpdateMediaInput, UpdateOfficeInput, UpdatePolicyAssetGroupInput, UpdatePolicyAssetInput, UpdatePolicyDocumentInput, UpdatePolicyInput, UpdatePolicyInputData, UpdatePolicyNoteInput, UpdateRegistryInput, UpdateRestorationInput, UpdateUserInput, UpdateUserPermissionInput, UserInput, UsersUserUserTypeChoices } from './queries'

export function AddAppraisalMediaInputSchema(): yup.SchemaOf<AddAppraisalMediaInput> {
  return yup.object({
    appraisalId: yup.string().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    mediaData: yup.lazy(() => yup.mixed()) as never
  })
}

export function AddAssetMediaInputSchema(): yup.SchemaOf<AddAssetMediaInput> {
  return yup.object({
    assetId: yup.string().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    mediaData: yup.lazy(() => yup.mixed()) as never
  })
}

export function AddConditionStatusReportMediaInputSchema(): yup.SchemaOf<AddConditionStatusReportMediaInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conditionStatusReportId: yup.string().required(),
    mediaData: yup.lazy(() => yup.mixed()) as never
  })
}

export function AddRestorationMediaInputSchema(): yup.SchemaOf<AddRestorationMediaInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    mediaData: yup.lazy(() => yup.mixed()) as never,
    restorationId: yup.string().required()
  })
}

export function AddUserObjectPermissionFromCollectionInputSchema(): yup.SchemaOf<AddUserObjectPermissionFromCollectionInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    collectionIds: yup.array().of(yup.string()).optional(),
    userId: yup.string()
  })
}

export function AddUserObjectPermissionInputSchema(): yup.SchemaOf<AddUserObjectPermissionInput> {
  return yup.object({
    assetIds: yup.array().of(yup.string()).optional(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    userId: yup.string().required()
  })
}

export function AddUserPermissionInputSchema(): yup.SchemaOf<AddUserPermissionInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    permissions: yup.array().of(yup.string()).optional()
  })
}

export function AddUserSignatureInputSchema(): yup.SchemaOf<AddUserSignatureInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    file: (yup.mixed().defined() as any).defined(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    userId: yup.string().required()
  })
}

export function AddressInputSchema(): yup.SchemaOf<AddressInput> {
  return yup.object({
    country: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    countryCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    formatted: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    latitude: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    locality: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    longitude: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    postalCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    raw: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    route: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    state: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    stateCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    streetNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function AppraisalInputSchema(): yup.SchemaOf<AppraisalInput> {
  return yup.object({
    appraisalAsset: yup.string(),
    appraisalConservationStatus: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    appraisalDate: yup.mixed(),
    appraisalEvaluator: yup.string().required(),
    appraisalLocation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    appraisalMotivation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    appraisalStatus: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    location: yup.lazy(() => yup.mixed()) as never,
    valueCarryingValue: yup.lazy(() => yup.mixed()) as never,
    valueEstimatedValue: yup.lazy(() => yup.mixed()) as never,
    valueInformationAuthorCoefficient: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    valueInformationInfo: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    valueInformationNote: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    valueInformationQuotesSimilarAssets: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function AssetDocumentAttachmentInputSchema(): yup.SchemaOf<AssetDocumentAttachmentInput> {
  return yup.object({
    assetDocumentId: yup.string().required(),
    file: (yup.mixed().defined() as any),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function AssetDocumentInputSchema(): yup.SchemaOf<AssetDocumentInput> {
  return yup.object({
    archiveNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    assetId: yup.string(),
    attachments: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional(),
    coaType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    contractSubscriber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    curator: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    description: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    documentType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    editor: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    expirationDate: yup.mixed(),
    fineArtsIssueType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    isClassified: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isCriticalCatalog: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isTemporaryExport: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isTemporaryImport: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    issuer: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    otherDocumentType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    publishingDate: yup.mixed(),
    recipient: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    releaseDate: yup.mixed(),
    subscriptionDate: yup.mixed(),
    title: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function AssetElementInputSchema(): yup.SchemaOf<AssetElementInput> {
  return yup.object({
    assetId: yup.string(),
    description: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    materials: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function AssetInputSchema(): yup.SchemaOf<AssetInput> {
  return yup.object({
    archiveNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    artistProofNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    assetPresentValues: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional(),
    audioVideoLength: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    audioVideoLengthUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    authorEntityId: yup.string().required(),
    banknotePrinter: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    barriersDetails: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    baseDetails: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    bibliographyNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    bookContainer: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    bookbinding: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    carat: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    carryingValueAcquisition: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    carryingValueAmount: yup.lazy(() => yup.mixed()) as never,
    carryingValueFile: (yup.mixed().defined() as any),
    carryingValueFileTitle: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    carryingValueLastAcquisitionDate: yup.mixed(),
    carryingValueNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    carryingValueOrigin: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    catalogNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    catalogingAuthor: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    category: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    centuryEndDate: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    centuryEndDateWindow: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    centuryStartDate: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    centuryStartDateWindow: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    circulation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    classificationEng: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    classificationFra: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    classificationGer: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    classificationIta: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    classificationPhilatelic: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    classificationSpa: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    classificationUsa: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    clips: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    clothCovering: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coinCirculationPeriod: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coinComposition: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coinIdentificationCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coinIssueReason: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coinMintIssuer: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coinPeriod: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coinPlacement: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coinPlacementNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coinTitle: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    color: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coloring: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    commonName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    compositionDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservationMethod: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservationState: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    containerDetails: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    copyrightAndPropertyRestrictions: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    corner: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coverType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    creationDate: yup.mixed(),
    creationDateNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    creationPeriod: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    criticalCatalogue: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    currency: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    currentValue: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    dateEndDate: yup.mixed(),
    dateStartDate: yup.mixed(),
    datedObjectNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    datingType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    description: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    dimensionsNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    discoveryAuthor: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    discoveryDate: yup.mixed(),
    discoveryNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    discoveryPlace: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    discoverySite: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    distribution: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    dustJacket: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    dynamicNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    edge: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    editionNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    enviromentalConditionsNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    externalDecorations: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    fileSize: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    fileSizeUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    finishing: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    firstDraftNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    fiscalValue: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    flyleaf: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    footEdge: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    foreEdge: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    frameDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    frameManufacturer: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    frameMaterial: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    frontCover: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    glueing: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    grossDepth: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    grossDiameter: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    grossDimensionsAcquisition: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    grossHeight: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    grossLengthUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    grossWeight: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    grossWeightUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    grossWidth: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    handlingRequirements: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    hardwareToolsInstallation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasBarriers: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasBase: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasContainer: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasFrame: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasFullDatetime: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasHumanAnimalPresence: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasLabelsStamps: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasLoop: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasOriginalFrame: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasOtherAutographed: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasPeriod: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasWoodFrame: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasYear: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    headband: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    headcap: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    holographicStripe: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    humanAnimalPresenceNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    infoNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    injuryRisk: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    injuryRiskDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    interiorDecorations: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    internationalCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    inventoryNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    isArtMultiple: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isArtistProof: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isAudio: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isCenturyApprox: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isCenturyEndDateBc: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isCenturyInterval: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isCenturyStartDateBc: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isComposed: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isDateApprox: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isDateEndDateBc: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isDateInterval: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isDateStartDateBc: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isDatedObject: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isDynamic: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isEdition: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isFirstDraft: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isMaster: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isNotifiedCulturalProperty: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isSignedObject: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isTitledObject: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isValuableFrame: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isVideo: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isYearApprox: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isYearEndDateBc: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isYearInterval: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isYearStartDateBc: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    label: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    labelsStampsNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    legalStatus: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    legend: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    lenderRequests: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    lightUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    manufactoringTechniques: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    manufacturerId: yup.string(),
    masterLocation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    material: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    mechanism: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    methodOfUse: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    mintMadeErrors: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    mintingLastDate: yup.mixed(),
    mintingLastDateNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    mouldingSupportBase: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    multipleNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    netDepth: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    netDiameter: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    netDimensionsAcquisition: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    netHeight: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    netLengthUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    netWeight: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    netWeightUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    netWidth: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    nft: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    nftNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    nominalValue: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    notifiedPropertyNote: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    numberOfElements: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    objectSetupAuthor: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    optimalHumidity: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    optimalLightLevelIntensity: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    optimalTemperature: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    orientation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    originNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    otherAutographedNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    otherModel: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    paperType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    physicalFeaturesElements: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional(),
    placement: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    postageMark: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    printerId: yup.string(),
    printingErrors: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    printingLastDate: yup.mixed(),
    printingLastDateNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    printingType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    producerId: yup.string(),
    productionMode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    raisedBands: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    rarityDegree: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    rarityDegreeNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    rarityDegreePhilatelic: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    rearCover: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    relatedPhysicalWork: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    relevantAwards: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    relief: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reminting: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    replacedParts: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reprinting: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    resolution: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    resolutionUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    rim: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    rotationAxes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    rubber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    scientificName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    score: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    securityThread: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    series: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    seriesDetails: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    settingNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    shape: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    signedObjectNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    signings: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    sku: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    slots: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    spine: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    square: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    stampCenteringAndMargins: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    stampFormat: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    stampIndentationType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    stampPrintingTechnique: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    stampRealization: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    stateOfConservation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    subcategory: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    surfaceCharacteristics: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    taxonomyClass: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    taxonomyDomain: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    taxonomyFamily: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    taxonomyGenus: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    taxonomyKingdom: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    taxonomyNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    taxonomyOrder: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    taxonomyPhylum: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    taxonomyTribe: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    technique: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    temperatureUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    title: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    titledObjectNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    topEdge: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    usage: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    validated: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable().defined(),
    variants: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    videomakerId: yup.string(),
    watermark: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    woodFrameDetails: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    yearEndDate: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    yearStartDate: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable()
  })
}

export function AssetPresentValueInputSchema(): yup.SchemaOf<AssetPresentValueInput> {
  return yup.object({
    amount: yup.lazy(() => yup.mixed()) as never,
    assetId: yup.string(),
    authorId: yup.string(),
    estimateDate: yup.mixed(),
    estimateReason: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    file: (yup.mixed().defined() as any),
    fileTitle: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export const BaseEventLogAuctionRightsCurrencyChoicesSchema = yup.mixed().oneOf([BaseEventLogAuctionRightsCurrencyChoices.Chf, BaseEventLogAuctionRightsCurrencyChoices.Eur, BaseEventLogAuctionRightsCurrencyChoices.Gbp, BaseEventLogAuctionRightsCurrencyChoices.Jpy, BaseEventLogAuctionRightsCurrencyChoices.Usd]);

export const BaseEventLogExternalEntityChoicesSchema = yup.mixed().oneOf([BaseEventLogExternalEntityChoices.Appraisal, BaseEventLogExternalEntityChoices.Collection, BaseEventLogExternalEntityChoices.CsReport, BaseEventLogExternalEntityChoices.Exhibition, BaseEventLogExternalEntityChoices.Logistics, BaseEventLogExternalEntityChoices.NoEntity, BaseEventLogExternalEntityChoices.Policy, BaseEventLogExternalEntityChoices.Restoration]);

export const BaseEventLogMaximumPriceCurrencyChoicesSchema = yup.mixed().oneOf([BaseEventLogMaximumPriceCurrencyChoices.Chf, BaseEventLogMaximumPriceCurrencyChoices.Eur, BaseEventLogMaximumPriceCurrencyChoices.Gbp, BaseEventLogMaximumPriceCurrencyChoices.Jpy, BaseEventLogMaximumPriceCurrencyChoices.Usd]);

export const BaseEventLogMinimumPriceCurrencyChoicesSchema = yup.mixed().oneOf([BaseEventLogMinimumPriceCurrencyChoices.Chf, BaseEventLogMinimumPriceCurrencyChoices.Eur, BaseEventLogMinimumPriceCurrencyChoices.Gbp, BaseEventLogMinimumPriceCurrencyChoices.Jpy, BaseEventLogMinimumPriceCurrencyChoices.Usd]);

export const BaseEventLogReservePriceCurrencyChoicesSchema = yup.mixed().oneOf([BaseEventLogReservePriceCurrencyChoices.Chf, BaseEventLogReservePriceCurrencyChoices.Eur, BaseEventLogReservePriceCurrencyChoices.Gbp, BaseEventLogReservePriceCurrencyChoices.Jpy, BaseEventLogReservePriceCurrencyChoices.Usd]);

export const BaseEventLogValueCurrencyChoicesSchema = yup.mixed().oneOf([BaseEventLogValueCurrencyChoices.Chf, BaseEventLogValueCurrencyChoices.Eur, BaseEventLogValueCurrencyChoices.Gbp, BaseEventLogValueCurrencyChoices.Jpy, BaseEventLogValueCurrencyChoices.Usd]);

export function CertificateInputSchema(): yup.SchemaOf<CertificateInput> {
  return yup.object({
    cancelReplace: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    cancelReplaceNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    certificateType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    creationDate: yup.mixed(),
    grouping: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    language: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    printTemplate: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function ChangeAssetCategoryInputSchema(): yup.SchemaOf<ChangeAssetCategoryInput> {
  return yup.object({
    authorEntityId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    category: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    subcategory: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required()
  })
}

export function ChangePasswordInputSchema(): yup.SchemaOf<ChangePasswordInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    confirmPassword: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    newPassword: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    oldPassword: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required()
  })
}

export function CloseAppraisalInputSchema(): yup.SchemaOf<CloseAppraisalInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function CloseConditionStatusReportInputSchema(): yup.SchemaOf<CloseConditionStatusReportInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function CloseRestorationInputSchema(): yup.SchemaOf<CloseRestorationInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function CollectionInputSchema(): yup.SchemaOf<CollectionInput> {
  return yup.object({
    assetSet: yup.array().of(yup.string()).optional(),
    description: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    image: (yup.mixed().defined() as any),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CompanyContactInputSchema(): yup.SchemaOf<CompanyContactInput> {
  return yup.object({
    companyContact: yup.string().required(),
    main: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable().defined(),
    relatedCompany: yup.string().required()
  })
}

export function ConditionStatusReportInputSchema(): yup.SchemaOf<ConditionStatusReportInput> {
  return yup.object({
    assetSet: yup.array().of(yup.string()).optional(),
    environmentalConditionsAbnormalHumidityEvent: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    environmentalConditionsAbnormalLightEvent: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    environmentalConditionsAbnormalTemperatureEvent: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    environmentalConditionsLightUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    environmentalConditionsOptimalHumidity: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    environmentalConditionsOptimalLightLevelIntensity: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    environmentalConditionsOptimalTemperature: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    environmentalConditionsTemperatureUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exhibitionAddress: yup.lazy(() => yup.mixed()) as never,
    exhibitionCurator: yup.string(),
    exhibitionEventFrom: yup.mixed(),
    exhibitionEventTo: yup.mixed(),
    exhibitionHostEntity: yup.string(),
    exhibitionLender: yup.string(),
    exhibitionLoanFrom: yup.mixed(),
    exhibitionLoanTo: yup.mixed(),
    exhibitionLocation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exhibitionName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exhibitionNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exhibitionPermanent: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    exhibitionPlanner: yup.string(),
    exhibitionTitle: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsAirConditioningTransportConditions: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsCarrier: yup.string(),
    logisticsDeliveryAddress: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsDeliveryCity: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsDeliveryCountry: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsDeliveryDate: yup.mixed(),
    logisticsDeliveryLocation: yup.lazy(() => yup.mixed()) as never,
    logisticsDeliveryState: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsDeliveryZip: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsNumberOfPackages: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    logisticsPickupAddress: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsPickupCity: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsPickupCountry: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsPickupDate: yup.mixed(),
    logisticsPickupLocation: yup.lazy(() => yup.mixed()) as never,
    logisticsPickupState: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsPickupZip: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    logisticsRecipient: yup.string(),
    logisticsSender: yup.string(),
    reportAsset: yup.string(),
    reportCompany: yup.string(),
    reportDate: yup.mixed(),
    reportDetailsAssetCondition: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportDetailsAssetDamageDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportDetailsExamConditions: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportDetailsExamConditionsNote: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportDetailsExamLocation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportDetailsExaminedPackages: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportDetailsExhaminationTimeTechnicalDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportDetailsPackagingGeneralConditions: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportDetailsPackagingStatusDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportDetailsProtectionsSupportsCondition: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportDetailsProtectionsSupportsDamageDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportExaminationType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    reportExaminer: yup.string(),
    reportMotivation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    reportMotivationDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reportStatus: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    reportType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    settingsConservation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    settingsExaminerComments: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    settingsHandlingRequirements: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    settingsHasBarriers: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    settingsInjuryRisk: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    settingsLenderRequests: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    settingsNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    valueEstimatedValue: yup.lazy(() => yup.mixed()) as never,
    valueEstimatedValueExaminationTime: yup.lazy(() => yup.mixed()) as never,
    valuePercentageDepreciation: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable()
  })
}

export function CreateAppraisalInputSchema(): yup.SchemaOf<CreateAppraisalInput> {
  return yup.object({
    appraisalData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateAssetDocumentAttachmentInputSchema(): yup.SchemaOf<CreateAssetDocumentAttachmentInput> {
  return yup.object({
    assetDocumentAttachmentData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateAssetDocumentInputSchema(): yup.SchemaOf<CreateAssetDocumentInput> {
  return yup.object({
    assetDocumentData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateAssetElementInputSchema(): yup.SchemaOf<CreateAssetElementInput> {
  return yup.object({
    assetElementData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateAssetInputSchema(): yup.SchemaOf<CreateAssetInput> {
  return yup.object({
    assetData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateAssetPresentValueInputSchema(): yup.SchemaOf<CreateAssetPresentValueInput> {
  return yup.object({
    assetPresentValueData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateCertificateInputSchema(): yup.SchemaOf<CreateCertificateInput> {
  return yup.object({
    certificateData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateCertificateTemplateInputSchema(): yup.SchemaOf<CreateCertificateTemplateInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    file: (yup.mixed().defined() as any).defined(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateCollectionInputSchema(): yup.SchemaOf<CreateCollectionInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    collectionData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateCompanyContactInputSchema(): yup.SchemaOf<CreateCompanyContactInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    companyContactData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateConditionStatusReportInputSchema(): yup.SchemaOf<CreateConditionStatusReportInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conditionStatusReportData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateEventLogInputSchema(): yup.SchemaOf<CreateEventLogInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventLogData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateExhibitionInputSchema(): yup.SchemaOf<CreateExhibitionInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exhibitionData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateInsuranceInputSchema(): yup.SchemaOf<CreateInsuranceInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    insuranceData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateMediaInputSchema(): yup.SchemaOf<CreateMediaInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    mediaData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateOfficeInputSchema(): yup.SchemaOf<CreateOfficeInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    officeData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreatePolicyAssetInputSchema(): yup.SchemaOf<CreatePolicyAssetInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    overrideChangeDate: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyAssetData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreatePolicyDocumentInputSchema(): yup.SchemaOf<CreatePolicyDocumentInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    file: (yup.mixed().defined() as any).defined(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyId: yup.string().required()
  })
}

export function CreatePolicyInputSchema(): yup.SchemaOf<CreatePolicyInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreatePolicyNoteInputSchema(): yup.SchemaOf<CreatePolicyNoteInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyNoteData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateRegistryInputSchema(): yup.SchemaOf<CreateRegistryInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    registryData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateRegistryWithCompanyContactInputSchema(): yup.SchemaOf<CreateRegistryWithCompanyContactInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    companyContactData: yup.lazy(() => yup.mixed()) as never,
    registryData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateRestorationInputSchema(): yup.SchemaOf<CreateRestorationInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    restorationData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateUserInputSchema(): yup.SchemaOf<CreateUserInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    userData: yup.lazy(() => yup.mixed()) as never
  })
}

export function DeleteAppraisalInputSchema(): yup.SchemaOf<DeleteAppraisalInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteAppraisalMediaInputSchema(): yup.SchemaOf<DeleteAppraisalMediaInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    mediaId: yup.string().required()
  })
}

export function DeleteAssetCarryingValueFileInputSchema(): yup.SchemaOf<DeleteAssetCarryingValueFileInput> {
  return yup.object({
    assetId: yup.string().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function DeleteAssetDocumentAttachmentInputSchema(): yup.SchemaOf<DeleteAssetDocumentAttachmentInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteAssetDocumentInputSchema(): yup.SchemaOf<DeleteAssetDocumentInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function DeleteAssetElementInputSchema(): yup.SchemaOf<DeleteAssetElementInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function DeleteAssetInputSchema(): yup.SchemaOf<DeleteAssetInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteAssetMediaInputSchema(): yup.SchemaOf<DeleteAssetMediaInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    mediaId: yup.string().required()
  })
}

export function DeleteAssetPresentValueInputSchema(): yup.SchemaOf<DeleteAssetPresentValueInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function DeleteCertificateInputSchema(): yup.SchemaOf<DeleteCertificateInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function DeleteCertificateTemplateInputSchema(): yup.SchemaOf<DeleteCertificateTemplateInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function DeleteCollectionInputSchema(): yup.SchemaOf<DeleteCollectionInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteCompanyContactInputSchema(): yup.SchemaOf<DeleteCompanyContactInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteConditionStatusReportInputSchema(): yup.SchemaOf<DeleteConditionStatusReportInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteConditionStatusReportMediaInputSchema(): yup.SchemaOf<DeleteConditionStatusReportMediaInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    mediaId: yup.string().required()
  })
}

export function DeleteEventLogInputSchema(): yup.SchemaOf<DeleteEventLogInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteExhibitionInputSchema(): yup.SchemaOf<DeleteExhibitionInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteInsuranceInputSchema(): yup.SchemaOf<DeleteInsuranceInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteMediaInputSchema(): yup.SchemaOf<DeleteMediaInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteOfficeInputSchema(): yup.SchemaOf<DeleteOfficeInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeletePolicyAssetInputSchema(): yup.SchemaOf<DeletePolicyAssetInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    overrideChangeDate: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function DeletePolicyDocumentInputSchema(): yup.SchemaOf<DeletePolicyDocumentInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function DeletePolicyInputSchema(): yup.SchemaOf<DeletePolicyInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeletePolicyNoteInputSchema(): yup.SchemaOf<DeletePolicyNoteInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteRegistryInputSchema(): yup.SchemaOf<DeleteRegistryInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteRestorationInputSchema(): yup.SchemaOf<DeleteRestorationInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteRestorationMediaInputSchema(): yup.SchemaOf<DeleteRestorationMediaInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    mediaId: yup.string().required()
  })
}

export function DeleteUserInputSchema(): yup.SchemaOf<DeleteUserInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteUserSignatureInputSchema(): yup.SchemaOf<DeleteUserSignatureInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DetachAssetFromAppraisalInputSchema(): yup.SchemaOf<DetachAssetFromAppraisalInput> {
  return yup.object({
    assetId: yup.string().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DetachAssetFromCollectionInputSchema(): yup.SchemaOf<DetachAssetFromCollectionInput> {
  return yup.object({
    assetId: yup.string().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DetachAssetFromConditionStatusReportInputSchema(): yup.SchemaOf<DetachAssetFromConditionStatusReportInput> {
  return yup.object({
    assetId: yup.string().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DetachAssetFromExhibitionInputSchema(): yup.SchemaOf<DetachAssetFromExhibitionInput> {
  return yup.object({
    assetId: yup.string().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DetachAssetFromRestorationInputSchema(): yup.SchemaOf<DetachAssetFromRestorationInput> {
  return yup.object({
    assetId: yup.string().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DuplicatePolicyInputSchema(): yup.SchemaOf<DuplicatePolicyInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyId: yup.string()
  })
}

export function EventLogInputSchema(): yup.SchemaOf<EventLogInput> {
  return yup.object({
    acquisitionType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    actionType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    assetSet: yup.array().of(yup.string()).optional(),
    auctionDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    auctionRights: yup.lazy(() => yup.mixed()) as never,
    broker: yup.string(),
    collectionPublicName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    commerciallyAvailable: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    commission: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    document: (yup.mixed().defined() as any),
    endDate: yup.mixed(),
    eventType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    externalEntity: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    externalId: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    hideOwner: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    host: yup.string(),
    locationDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    lotNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    maximumPrice: yup.lazy(() => yup.mixed()) as never,
    minimumPrice: yup.lazy(() => yup.mixed()) as never,
    newOwner: yup.string(),
    note: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    origin: yup.string(),
    owner: yup.string(),
    reason: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    reservePrice: yup.lazy(() => yup.mixed()) as never,
    sellingLocation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    sold: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    startDate: yup.mixed().defined(),
    value: yup.lazy(() => yup.mixed()) as never
  })
}

export function ExhibitionInputSchema(): yup.SchemaOf<ExhibitionInput> {
  return yup.object({
    assetSet: yup.array().of(yup.string()).optional(),
    curator: yup.string(),
    description: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventFrom: yup.mixed(),
    eventLocation: yup.string(),
    eventLocationEntity: yup.string(),
    eventTo: yup.mixed(),
    hostEntity: yup.string().required(),
    image: (yup.mixed().defined() as any),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    organizer: yup.string(),
    permanent: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function ExportAppraisalPdfInputSchema(): yup.SchemaOf<ExportAppraisalPdfInput> {
  return yup.object({
    appraisalId: yup.string().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    lang: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function ExportAssetPdfInputSchema(): yup.SchemaOf<ExportAssetPdfInput> {
  return yup.object({
    assetId: yup.string().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    lang: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function ExportCollectionPdfInputSchema(): yup.SchemaOf<ExportCollectionPdfInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    collectionId: yup.string().required(),
    lang: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function ExportConditionStatusReportPdfInputSchema(): yup.SchemaOf<ExportConditionStatusReportPdfInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conditionStatusReportId: yup.string().required(),
    lang: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function ExportExhibitionPdfInputSchema(): yup.SchemaOf<ExportExhibitionPdfInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exhibitionId: yup.string().required(),
    lang: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function ExportPolicyPdfInputSchema(): yup.SchemaOf<ExportPolicyPdfInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function ExportRestorationPdfInputSchema(): yup.SchemaOf<ExportRestorationPdfInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    lang: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    restorationId: yup.string().required()
  })
}

export function ExtendPolicyInputSchema(): yup.SchemaOf<ExtendPolicyInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    endDate: yup.mixed(),
    policyId: yup.string(),
    totalInsuredPremium: yup.lazy(() => yup.mixed()) as never
  })
}

export function GenerateCertificateInputSchema(): yup.SchemaOf<GenerateCertificateInput> {
  return yup.object({
    cancelReplace: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    cancelReplaceNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    certificateTemplateId: yup.string(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasPdf: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string(),
    language: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    metafields: yup.mixed(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function GenerateGroupedCertificateInputSchema(): yup.SchemaOf<GenerateGroupedCertificateInput> {
  return yup.object({
    cancelReplace: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    cancelReplaceNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    certificateTemplateId: yup.string(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasPdf: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string(),
    language: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    metafields: yup.mixed(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyAssetsId: yup.array().of(yup.string()).optional()
  })
}

export function GenerateSplitCertificateInputSchema(): yup.SchemaOf<GenerateSplitCertificateInput> {
  return yup.object({
    cancelReplace: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    cancelReplaceNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    certificateTemplateId: yup.string(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasPdf: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string(),
    language: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    metafields: yup.mixed(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyAssetsId: yup.array().of(yup.string()).optional()
  })
}

export function GroupedPolicyAssetInputSchema(): yup.SchemaOf<GroupedPolicyAssetInput> {
  return yup.object({
    asset: yup.string(),
    catNat: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    coverTerrorism: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    coverType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coveredRiskType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    deliveryAddress: yup.lazy(() => yup.mixed()) as never,
    evaluationType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exemption: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    expiresAt: yup.mixed(),
    id: yup.string().required(),
    insuredValue: yup.lazy(() => yup.mixed()) as never,
    issuedAt: yup.mixed(),
    lenderAddress: yup.lazy(() => yup.mixed()) as never,
    lenderId: yup.string(),
    objectLocationEntityId: yup.string(),
    objectLocationOfficeId: yup.string(),
    pickupAddress: yup.lazy(() => yup.mixed()) as never,
    policy: yup.string(),
    shipperId: yup.string(),
    status: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function InsuranceInputSchema(): yup.SchemaOf<InsuranceInput> {
  return yup.object({
    catNat: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable().defined(),
    contractType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    coverageType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    currencyInsurancePremium: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    currencyInsuredValue: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    evaluationType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    insurancePremium: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    insuranceReason: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    insuredValue: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    note: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    policyNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    riskCoveredType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    terrorism: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable().defined()
  })
}

export function InvalidateCertificateInputSchema(): yup.SchemaOf<InvalidateCertificateInput> {
  return yup.object({
    certificateId: yup.string(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function InviteUserInputSchema(): yup.SchemaOf<InviteUserInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    expiresAt: yup.mixed().defined(),
    permissions: yup.array().of(yup.string().transform((value) =>( value === null ? undefined:value)).nullable()).optional(),
    validFrom: yup.mixed()
  })
}

export const ManagementAppraisalValueCarryingValueCurrencyChoicesSchema = yup.mixed().oneOf([ManagementAppraisalValueCarryingValueCurrencyChoices.Chf, ManagementAppraisalValueCarryingValueCurrencyChoices.Eur, ManagementAppraisalValueCarryingValueCurrencyChoices.Gbp, ManagementAppraisalValueCarryingValueCurrencyChoices.Jpy, ManagementAppraisalValueCarryingValueCurrencyChoices.Usd]);

export const ManagementAppraisalValueEstimatedValueCurrencyChoicesSchema = yup.mixed().oneOf([ManagementAppraisalValueEstimatedValueCurrencyChoices.Chf, ManagementAppraisalValueEstimatedValueCurrencyChoices.Eur, ManagementAppraisalValueEstimatedValueCurrencyChoices.Gbp, ManagementAppraisalValueEstimatedValueCurrencyChoices.Jpy, ManagementAppraisalValueEstimatedValueCurrencyChoices.Usd]);

export const ManagementAssetPresentValueAmountCurrencyChoicesSchema = yup.mixed().oneOf([ManagementAssetPresentValueAmountCurrencyChoices.Chf, ManagementAssetPresentValueAmountCurrencyChoices.Eur, ManagementAssetPresentValueAmountCurrencyChoices.Gbp, ManagementAssetPresentValueAmountCurrencyChoices.Jpy, ManagementAssetPresentValueAmountCurrencyChoices.Usd]);

export const ManagementConditionStatusReportValueEstimatedValueCurrencyChoicesSchema = yup.mixed().oneOf([ManagementConditionStatusReportValueEstimatedValueCurrencyChoices.Chf, ManagementConditionStatusReportValueEstimatedValueCurrencyChoices.Eur, ManagementConditionStatusReportValueEstimatedValueCurrencyChoices.Gbp, ManagementConditionStatusReportValueEstimatedValueCurrencyChoices.Jpy, ManagementConditionStatusReportValueEstimatedValueCurrencyChoices.Usd]);

export const ManagementConditionStatusReportValueEstimatedValueExaminationTimeCurrencyChoicesSchema = yup.mixed().oneOf([ManagementConditionStatusReportValueEstimatedValueExaminationTimeCurrencyChoices.Chf, ManagementConditionStatusReportValueEstimatedValueExaminationTimeCurrencyChoices.Eur, ManagementConditionStatusReportValueEstimatedValueExaminationTimeCurrencyChoices.Gbp, ManagementConditionStatusReportValueEstimatedValueExaminationTimeCurrencyChoices.Jpy, ManagementConditionStatusReportValueEstimatedValueExaminationTimeCurrencyChoices.Usd]);

export const ManagementInsuranceContractTypeChoicesSchema = yup.mixed().oneOf([ManagementInsuranceContractTypeChoices.Basket, ManagementInsuranceContractTypeChoices.Punctual]);

export const ManagementInsuranceCoverageTypeChoicesSchema = yup.mixed().oneOf([ManagementInsuranceCoverageTypeChoices.NailToNail, ManagementInsuranceCoverageTypeChoices.StayRisk, ManagementInsuranceCoverageTypeChoices.TravelRisk]);

export const ManagementInsuranceEvaluationTypeChoicesSchema = yup.mixed().oneOf([ManagementInsuranceEvaluationTypeChoices.All, ManagementInsuranceEvaluationTypeChoices.DeclaredValue, ManagementInsuranceEvaluationTypeChoices.EstimateAccepted]);

export const ManagementInsuranceInsuranceReasonChoicesSchema = yup.mixed().oneOf([ManagementInsuranceInsuranceReasonChoices.Exhibition, ManagementInsuranceInsuranceReasonChoices.ExhibitionTransport, ManagementInsuranceInsuranceReasonChoices.Loan, ManagementInsuranceInsuranceReasonChoices.Restauration, ManagementInsuranceInsuranceReasonChoices.RestaurationTransport, ManagementInsuranceInsuranceReasonChoices.StayInPlace, ManagementInsuranceInsuranceReasonChoices.Transport]);

export const ManagementInsuranceRiskCoveredTypeChoicesSchema = yup.mixed().oneOf([ManagementInsuranceRiskCoveredTypeChoices.AllRisk, ManagementInsuranceRiskCoveredTypeChoices.FirstRisk, ManagementInsuranceRiskCoveredTypeChoices.None]);

export const ManagementRestorationRestorationCostCurrencyChoicesSchema = yup.mixed().oneOf([ManagementRestorationRestorationCostCurrencyChoices.Chf, ManagementRestorationRestorationCostCurrencyChoices.Eur, ManagementRestorationRestorationCostCurrencyChoices.Gbp, ManagementRestorationRestorationCostCurrencyChoices.Jpy, ManagementRestorationRestorationCostCurrencyChoices.Usd]);

export function MediaInputSchema(): yup.SchemaOf<MediaInput> {
  return yup.object({
    audioVideoFileType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    creationDate: yup.mixed(),
    description: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    file: (yup.mixed().defined() as any),
    fileAuthor: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    fileSize: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    imageType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    isGlassPlexyAcetate: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isMainImage: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    matrixType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    mediaType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    photographicEquipment: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function MoneyInputSchema(): yup.SchemaOf<MoneyInput> {
  return yup.object({
    amount: yup.mixed(),
    currency: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required()
  })
}

export function OfficeInputSchema(): yup.SchemaOf<OfficeInput> {
  return yup.object({
    active: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable().defined(),
    address: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    city: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    country: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    main: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable().defined(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    officeAddress: yup.lazy(() => yup.mixed()) as never,
    phone: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    registry: yup.string().required(),
    state: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    zip: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function PolicyAssetInputSchema(): yup.SchemaOf<PolicyAssetInput> {
  return yup.object({
    asset: yup.string(),
    catNat: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    coverTerrorism: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    coverType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coveredRiskType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    createdBy: yup.string(),
    deliveryAddress: yup.lazy(() => yup.mixed()) as never,
    evaluationType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exemption: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    expiresAt: yup.mixed(),
    insuredValue: yup.lazy(() => yup.mixed()) as never,
    issuedAt: yup.mixed(),
    lenderAddress: yup.lazy(() => yup.mixed()) as never,
    lenderId: yup.string(),
    objectLocationEntityId: yup.string(),
    objectLocationOfficeId: yup.string(),
    pickupAddress: yup.lazy(() => yup.mixed()) as never,
    policy: yup.string(),
    shipperId: yup.string(),
    status: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function PolicyDocumentInputSchema(): yup.SchemaOf<PolicyDocumentInput> {
  return yup.object({
    description: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    extension: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    file: (yup.mixed().defined() as any).defined(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    weight: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable()
  })
}

export function PolicyInputSchema(): yup.SchemaOf<PolicyInput> {
  return yup.object({
    autoRenewal: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    brokerId: yup.string(),
    catNat: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    contractingPartyId: yup.string().required(),
    coverTerrorism: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    coverType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coveredRiskType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    evaluationType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventEntityId: yup.string().required(),
    eventFrom: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventLocationEntityId: yup.string().required(),
    eventName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventTo: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exemption: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    expiresAt: yup.mixed().defined(),
    hasVariableBasket: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    insuranceCompanyId: yup.string().required(),
    issuedAt: yup.mixed().defined(),
    offerCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    policyAssets: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional(),
    policyCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    policyDocuments: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional(),
    policyNote: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional(),
    policyStatus: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    policyType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    totalInsuredPremium: yup.lazy(() => yup.mixed()) as never,
    totalInsuredValue: yup.lazy(() => yup.mixed()) as never
  })
}

export function PolicyNoteInputSchema(): yup.SchemaOf<PolicyNoteInput> {
  return yup.object({
    content: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyId: yup.string()
  })
}

export function RegistryInputSchema(): yup.SchemaOf<RegistryInput> {
  return yup.object({
    activityPeriod: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    activityPlace: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    alias: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    artisticMovement: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    authorType: yup.array().of(yup.string().transform((value) =>( value === null ? undefined:value)).nullable()).optional(),
    billingAddress: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    birthDate: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    birthPlace: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    businessName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    categories: yup.array().of(yup.string().transform((value) =>( value === null ? undefined:value)).nullable()).optional(),
    categoriesCompany: yup.array().of(yup.string().transform((value) =>( value === null ? undefined:value)).nullable()).optional(),
    categoriesPerson: yup.array().of(yup.string().transform((value) =>( value === null ? undefined:value)).nullable()).optional(),
    company: yup.string(),
    confidentialNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    contactDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    countryCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    deathDate: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    deathPlace: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    displayName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    foundation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    fullName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    invoiceAddress: yup.lazy(() => yup.mixed()) as never,
    isAnonymousTenantDefault: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isAuthor: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isBrokerDefaultTenantDefault: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isCompany: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isInsuranceCompanyTenantDefault: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    isUnknownTenantDefault: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    mainContact: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    mobilePhone: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    note: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    phone: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    printCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    printName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    role: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    taxId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    webSite: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function RemoveUserObjectPermissionInputSchema(): yup.SchemaOf<RemoveUserObjectPermissionInput> {
  return yup.object({
    assetIds: yup.array().of(yup.string()).optional(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    userId: yup.string()
  })
}

export function RenewPolicyInputSchema(): yup.SchemaOf<RenewPolicyInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    endDate: yup.mixed(),
    policyId: yup.string(),
    startDate: yup.mixed(),
    totalInsuredPremium: yup.lazy(() => yup.mixed()) as never
  })
}

export function RenewUserInputSchema(): yup.SchemaOf<RenewUserInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function RequestUserResetPasswordInputSchema(): yup.SchemaOf<RequestUserResetPasswordInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required()
  })
}

export function ResetUserPasswordInputSchema(): yup.SchemaOf<ResetUserPasswordInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    confirmPassword: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    newPassword: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    resetPasswordToken: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function RestorationInputSchema(): yup.SchemaOf<RestorationInput> {
  return yup.object({
    conservativeDataAssetAlterations: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataConservationStatus: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataDeteriorationCauses: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataExaminationMethod: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataHistoryInterventions: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataIntervention: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataInterventionMaterials: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataInterventionProposal: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataMaintenancePreparationAssembly: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataNotesRestorationSheet: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataPreliminaryOperations: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataRestorationBibliography: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservativeDataTechnicalMethodologicalConsiderations: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    restorationAsset: yup.string(),
    restorationCollocationFeatures: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    restorationCompany: yup.string(),
    restorationCost: yup.lazy(() => yup.mixed()) as never,
    restorationDirector: yup.string().required(),
    restorationDocumentDate: yup.mixed(),
    restorationEndDate: yup.mixed(),
    restorationInventoryNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    restorationLocation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    restorationRestoredBy: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    restorationStartDate: yup.mixed(),
    restorationStatus: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required()
  })
}

export function RevertPolicyInputSchema(): yup.SchemaOf<RevertPolicyInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    historyId: yup.number().transform((value) => (isNaN(value) ? null:value)).nullable(),
    policyId: yup.string()
  })
}

export function SetMainSignatureInputSchema(): yup.SchemaOf<SetMainSignatureInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    signatureId: yup.string().required(),
    userId: yup.string().required()
  })
}

export function SignCertificateInputSchema(): yup.SchemaOf<SignCertificateInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export const SpinCertificateCertificateTypeChoicesSchema = yup.mixed().oneOf([SpinCertificateCertificateTypeChoices.PermanentCollection, SpinCertificateCertificateTypeChoices.TemporaryExhibition]);

export const SpinCertificateGroupingChoicesSchema = yup.mixed().oneOf([SpinCertificateGroupingChoices.Grouped, SpinCertificateGroupingChoices.Splitted, SpinCertificateGroupingChoices.Total]);

export const SpinPolicyAssetBasketHistoryCoverTypeChoicesSchema = yup.mixed().oneOf([SpinPolicyAssetBasketHistoryCoverTypeChoices.NailToNail, SpinPolicyAssetBasketHistoryCoverTypeChoices.StayRisk, SpinPolicyAssetBasketHistoryCoverTypeChoices.TravelRisk]);

export const SpinPolicyAssetBasketHistoryCoveredRiskTypeChoicesSchema = yup.mixed().oneOf([SpinPolicyAssetBasketHistoryCoveredRiskTypeChoices.AllRisk, SpinPolicyAssetBasketHistoryCoveredRiskTypeChoices.FirstRisk]);

export const SpinPolicyAssetBasketHistoryEvaluationTypeChoicesSchema = yup.mixed().oneOf([SpinPolicyAssetBasketHistoryEvaluationTypeChoices.AgreedValue, SpinPolicyAssetBasketHistoryEvaluationTypeChoices.DeclaredValue]);

export const SpinPolicyAssetBasketHistoryInsuredValueCurrencyChoicesSchema = yup.mixed().oneOf([SpinPolicyAssetBasketHistoryInsuredValueCurrencyChoices.Chf, SpinPolicyAssetBasketHistoryInsuredValueCurrencyChoices.Eur, SpinPolicyAssetBasketHistoryInsuredValueCurrencyChoices.Gbp, SpinPolicyAssetBasketHistoryInsuredValueCurrencyChoices.Jpy, SpinPolicyAssetBasketHistoryInsuredValueCurrencyChoices.Usd]);

export const SpinPolicyAssetBasketHistoryStatusChoicesSchema = yup.mixed().oneOf([SpinPolicyAssetBasketHistoryStatusChoices.Added, SpinPolicyAssetBasketHistoryStatusChoices.Initial, SpinPolicyAssetBasketHistoryStatusChoices.Other, SpinPolicyAssetBasketHistoryStatusChoices.Unchanged, SpinPolicyAssetBasketHistoryStatusChoices.Updated]);

export const SpinPolicyBasketHistoryStatusChoicesSchema = yup.mixed().oneOf([SpinPolicyBasketHistoryStatusChoices.Add, SpinPolicyBasketHistoryStatusChoices.Delete, SpinPolicyBasketHistoryStatusChoices.Initial, SpinPolicyBasketHistoryStatusChoices.Other, SpinPolicyBasketHistoryStatusChoices.Update]);

export const SpinPolicyEventsActionChoicesSchema = yup.mixed().oneOf([SpinPolicyEventsActionChoices.AddPolicyAsset, SpinPolicyEventsActionChoices.CertificateGeneration, SpinPolicyEventsActionChoices.Extension, SpinPolicyEventsActionChoices.ManualInvalidationCertificate, SpinPolicyEventsActionChoices.ManualTerminationPolicy, SpinPolicyEventsActionChoices.ModifiedDriverPolicy, SpinPolicyEventsActionChoices.ModifiedDriverPolicyAsset, SpinPolicyEventsActionChoices.RemovePolicyAsset, SpinPolicyEventsActionChoices.Termination]);

export function TerminatePolicyInputSchema(): yup.SchemaOf<TerminatePolicyInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    endDate: yup.mixed(),
    policyId: yup.string(),
    totalInsuredPremium: yup.lazy(() => yup.mixed()) as never
  })
}

export function ToggleUserIsActiveInputSchema(): yup.SchemaOf<ToggleUserIsActiveInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function ToggleUserUserTypeInputSchema(): yup.SchemaOf<ToggleUserUserTypeInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    expiration: yup.mixed(),
    id: yup.string().required()
  })
}

export function UpdateAppraisalInputSchema(): yup.SchemaOf<UpdateAppraisalInput> {
  return yup.object({
    appraisalData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function UpdateAssetDocumentAttachmentInputSchema(): yup.SchemaOf<UpdateAssetDocumentAttachmentInput> {
  return yup.object({
    assetDocumentAttachmentData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function UpdateAssetDocumentInputSchema(): yup.SchemaOf<UpdateAssetDocumentInput> {
  return yup.object({
    assetDocumentData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function UpdateAssetElementInputSchema(): yup.SchemaOf<UpdateAssetElementInput> {
  return yup.object({
    assetElementData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function UpdateAssetInputSchema(): yup.SchemaOf<UpdateAssetInput> {
  return yup.object({
    assetData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function UpdateAssetPresentValueInputSchema(): yup.SchemaOf<UpdateAssetPresentValueInput> {
  return yup.object({
    assetPresentValueData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function UpdateCertificateInputSchema(): yup.SchemaOf<UpdateCertificateInput> {
  return yup.object({
    certificateData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function UpdateCollectionInputSchema(): yup.SchemaOf<UpdateCollectionInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    collectionData: yup.lazy(() => yup.mixed()) as never,
    id: yup.string().required()
  })
}

export function UpdateCompanyContactInputSchema(): yup.SchemaOf<UpdateCompanyContactInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    companyContactData: yup.lazy(() => yup.mixed()) as never,
    id: yup.string().required()
  })
}

export function UpdateConditionStatusReportInputSchema(): yup.SchemaOf<UpdateConditionStatusReportInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conditionStatusReportData: yup.lazy(() => yup.mixed()) as never,
    id: yup.string().required()
  })
}

export function UpdateEventLogInputSchema(): yup.SchemaOf<UpdateEventLogInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventLogData: yup.lazy(() => yup.mixed()) as never,
    id: yup.string().required()
  })
}

export function UpdateExhibitionInputSchema(): yup.SchemaOf<UpdateExhibitionInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exhibitionData: yup.lazy(() => yup.mixed()) as never,
    id: yup.string().required()
  })
}

export function UpdateInsuranceInputSchema(): yup.SchemaOf<UpdateInsuranceInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    insuranceData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdateMediaInputSchema(): yup.SchemaOf<UpdateMediaInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    mediaData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdateOfficeInputSchema(): yup.SchemaOf<UpdateOfficeInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    officeData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdatePolicyAssetGroupInputSchema(): yup.SchemaOf<UpdatePolicyAssetGroupInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    overrideChangeDate: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyAssetsData: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional()
  })
}

export function UpdatePolicyAssetInputSchema(): yup.SchemaOf<UpdatePolicyAssetInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyAssetData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdatePolicyDocumentInputSchema(): yup.SchemaOf<UpdatePolicyDocumentInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    policyDocumentData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdatePolicyInputSchema(): yup.SchemaOf<UpdatePolicyInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    policyData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdatePolicyInputDataSchema(): yup.SchemaOf<UpdatePolicyInputData> {
  return yup.object({
    autoRenewal: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    brokerId: yup.string(),
    catNat: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    contractingPartyId: yup.string().required(),
    coverTerrorism: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    coverType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coveredRiskType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    evaluationType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventEntityId: yup.string().required(),
    eventFrom: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventLocationEntityId: yup.string().required(),
    eventName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventTo: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exemption: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    expiresAt: yup.mixed().defined(),
    hasVariableBasket: yup.boolean().transform((value) =>( value === null ? undefined:value)).nullable(),
    insuranceCompanyId: yup.string().required(),
    issuedAt: yup.mixed().defined(),
    offerCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    policyCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    policyStatus: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    totalInsuredPremium: yup.lazy(() => yup.mixed()) as never,
    totalInsuredValue: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdatePolicyNoteInputSchema(): yup.SchemaOf<UpdatePolicyNoteInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    policyNoteData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdateRegistryInputSchema(): yup.SchemaOf<UpdateRegistryInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    registryData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdateRestorationInputSchema(): yup.SchemaOf<UpdateRestorationInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    restorationData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdateUserInputSchema(): yup.SchemaOf<UpdateUserInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    userData: yup.lazy(() => yup.mixed().defined()) as never
  })
}

export function UpdateUserPermissionInputSchema(): yup.SchemaOf<UpdateUserPermissionInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    permissions: yup.array().of(yup.string().transform((value) =>( value === null ? undefined:value)).nullable()).optional()
  })
}

export function UserInputSchema(): yup.SchemaOf<UserInput> {
  return yup.object({
    country: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    currency: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    expiresAt: yup.mixed(),
    language: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    phone: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    timezone: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    userType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    validFrom: yup.mixed()
  })
}

export const UsersUserUserTypeChoicesSchema = yup.mixed().oneOf([UsersUserUserTypeChoices.Default, UsersUserUserTypeChoices.External, UsersUserUserTypeChoices.Internal]);
